import React from "react"

// Components
import "./style.css"

const SliderArrow = ({ onClick, direction}) => {
    return <div
        className={`slider-arrow ${direction === "next" ? "slider-arrow--next" : direction === "prev" ? "slider-arrow--prev" : ""}`}
        onClick={onClick} />
}

export default SliderArrow



// WEBPACK FOOTER //
// ./src/components/SliderArrow/index.js